import { render, staticRenderFns } from "./pie2d.vue?vue&type=template&id=0fdf0503&scoped=true"
import script from "./pie2d.vue?vue&type=script&lang=js"
export * from "./pie2d.vue?vue&type=script&lang=js"
import style0 from "./pie2d.vue?vue&type=style&index=0&id=0fdf0503&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdf0503",
  null
  
)

export default component.exports